import {Component, OnInit, Renderer, ViewChild, ElementRef, OnDestroy} from "@angular/core";
import {UserService} from "./services/data/user.service";
import {AuthentService} from "./services/authent.service";
import {BusinessService} from "./services/data/business.service";
import {CookieService} from "angular2-cookie/core";
import {CurrentBusinessService} from "./services/communication/currentBusinessService";
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {BusinessRight} from "./model/business-right";
import {CurrentEventService} from "./services/communication/currentEventService";
import {FileUploaderService} from "./services/communication/fileUploaderService";
import {UrlService} from "./services/url.service";
import {FileUploader, FileUploaderOptions, FileItem, ParsedResponseHeaders} from "ng2-file-upload/index";
import {ConfigurationService} from "./services/configuration.service";
import {Subscription} from "rxjs";
import {Picture} from "./model/picture";

declare const $: any;
declare const window: any;
declare const ga: Function;

@Component({
  selector: 'app',
  providers: [],
  template: require('./app.component.html'),
  styles: [
    require('./app.component.scss'),
    require('../assets/style/app.scss')
  ]
})
export class AppComponent implements OnInit, OnDestroy {

  isLogged: boolean = false;
  isUploading: boolean = false;
  private token: string = null;

  userRight: BusinessRight;

  eventId: number = -1;

  private businessId: number;

  notificationOption = {
    position: ['top', 'right'],
    maxStack: 3,
    timeOut: 4000,
    showProgressBar: true
  };

  uploader: FileUploader;
  uploaderOptions: FileUploaderOptions = {};
  showUpload: boolean = false;
  minimizedUpload: boolean = false;

  @ViewChild('uploadInput') fileInput: ElementRef;

  env: string = null;

  private paramSubscription: Subscription = null;
  private eventSubscription: Subscription = null;
  private uploadShowSubscription: Subscription = null;
  private loginSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
    this.eventSubscription.unsubscribe();
    this.uploadShowSubscription.unsubscribe();

    if (this.loginSubscription != null) {
      this.loginSubscription.unsubscribe();
    }
  }

  constructor(private userService: UserService,
              private authentService: AuthentService,
              private cookie: CookieService,
              private businessService: BusinessService,
              private currentBusinessService: CurrentBusinessService,
              private activatedRoute: ActivatedRoute,
              private currentEvent: CurrentEventService,
              private fileUploader: FileUploaderService, private urlService: UrlService,
              private renderer: Renderer, private router: Router, private conf: ConfigurationService) {
    this.env = this.conf.getEnvironmentAsString();

    this.eventSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // google analytics page change
        if (this.env == 'prod') {
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
        }
      }
    });

    this.uploadShowSubscription = this.fileUploader.showChanged$.subscribe(
      state => {
        if (state === 'upload') {
          this.minimizedUpload = false;
          this.showUpload = true;
          let event = new MouseEvent('click', {bubbles: true});

          this.renderer.invokeElementMethod(
            this.fileInput.nativeElement, 'dispatchEvent', [event]);
        }

        if (state === 'minimize') {
          this.minimizeUpload();
        }

        if (state === 'show') {
          this.minimizedUpload = false;
          this.showUpload = true;
        }

        if (state === 'close') {
          this.hideUpload();
        }
      }
    );
  }

  private initApp() {
    let business = this.cookie.get('us_b');
    let token = this.cookie.get('us_t');

    if (token != null) {
      this.token = token;
      this.authentService.setToken(this.token);
      this.getPrincipal();
    }

    if (business != null) {
      let businessObject = JSON.parse(business);
      this.businessId = businessObject.id;
      businessObject.id = this.businessId;

      this.currentBusinessService.currentBusiness = businessObject;
    }

    this.loginSubscription = this.authentService.loggedIn$.subscribe(
      logged => this.loggedChanged(logged)
    );

    this.initUploader();
  }

  loggedChanged(logged: boolean) {
    this.isLogged = logged;

    this.setUploaderToken();
  }

  ngOnInit(): void {
    $('.app-container').remove();

    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        // if (this.token == null) {
        //   this.token = param['access_token'];
        // }

        this.initApp();
      });
  }

  getPrincipal(): void {
    this.userService.getPrincipal()
      .subscribe(
        user => {
          this.authentService.setUser(user);

          if (this.businessId != null) {
            this.loadBusiness(this.businessId);
          }

          this.loadBusinesses();
        },
        error => {
          this.authentService.logout();
        }
      );
  }

  getRight(): void {
    this.businessService.getRight(this.currentBusinessService.currentBusiness.id).subscribe(
      right => {
        this.userRight = right;
        this.authentService.setRight(right);
      }
    );
  }

  eventChanged(event) {
    this.eventId = event;
  }

  loadBusiness(businessId: number) {
    this.businessService.getBusiness(businessId).subscribe(
      business => {
        this.currentBusinessService.changeBusiness(business);
        this.getRight();
      }
    )
  }

  loadBusinesses() {
    this.businessService.getBusinesses().subscribe(
      businesses => {
        if (businesses.length > 1 || businesses.length == 0) {
          this.currentBusinessService.changeBusinesses(businesses);
          if (this.businessId == null) {
            this.router.navigateByUrl('/businesses');
          }
        } else {
          this.currentBusinessService.changeBusinesses(businesses);
          this.currentBusinessService.changeBusiness(businesses[0]);
          // this.router.navigateByUrl('/events');
          this.getRight();
        }
      }
    )
  }

  setUploaderToken() {
    let headers = {
      name: 'Authorization',
      value: 'Bearer ' + this.authentService.getToken()
    };

    this.uploaderOptions.headers = [headers];
    this.uploader.setOptions(this.uploaderOptions);
  }

  initUploader() {
    this.uploader = new FileUploader({
      autoUpload: true
    });

    this.setUploaderToken();

    this.uploader.onSuccessItem = (item: FamiliesFileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      this.fileUploader.addPicture(response, item.eventId);

      let picture: Picture = JSON.parse(response);

      item['done'] = true;
      item['fileId'] = picture.id;
      item['miniatureUrl'] = this.urlService.getPictureMiniatureUrl(item['eventId'], picture.id);
    };

    this.uploader.onErrorItem = (item: any, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response != null && response != '') {
        let error = JSON.parse(response);

        if (error.errors != null && error.errors[0].code == 'constraint.violation') {
          item.errorMessage = 'Mauvais format';
        } else {
          item.errorMessage = 'Erreur d\'ajout';
        }

        console.log("onErrorItem " + status, response);
      } else {
        item.errorMessage = 'Erreur d\'ajout';
      }
    };

    this.uploader.onAfterAddingFile = (item: FamiliesFileItem) => {
      this.uploader.options.itemAlias = 'file';
      item.withCredentials = false;
      item.eventId = this.currentEvent.currentEvent.id;
      item.url = this.urlService.getUploadEventPictureUrl(this.currentEvent.currentEvent.id);
      let headers = {
        name: 'Authorization',
        value: 'Bearer ' + this.authentService.getToken()
      };
      item.headers = headers;
    }
  }

  cancelAllUpload() {
    this.uploader.cancelAll();
    this.uploader.clearQueue();
    this.checkProgress();
  }

  closeUploadDone() {
    this.uploader.queue = this.uploader.queue.filter(item => item['done'] != true);
    this.checkProgress();
  }

  checkProgress() {
    if(this.uploader.queue!=null && this.uploader.queue.length==0) {
      this.uploader.progress = 0;
    }
  }

  reloadPagePictures() {
    this.fileUploader.reloadPage();
  }

  minimizeUpload() {
    if (this.minimizedUpload) {
      this.minimizedUpload = false;
    } else {
      this.minimizedUpload = true;
    }

    this.showUpload = true;
  }

  hideUpload() {
    this.minimizedUpload = false;
    this.showUpload = false;
  }
}

export class FamiliesFileItem extends FileItem {

  eventId: number;

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/app.component.ts